import React from "react";
import { Sparkles, CornerDownLeft } from "lucide-react";
import { KIND_LABEL } from "../../lib/searchApi";
import { cn } from "../../lib/utils";

const keep = (e) => e.preventDefault();

function Row({ r, on, onPick }) {
  return (
    <button type="button" data-testid={`global-search-result-${r.kind}-${r.code}`} onMouseDown={keep} onClick={() => onPick(r)}
            className={cn("w-full text-left px-3 py-1.5 flex items-center gap-3 text-[12.5px] transition-colors", on ? "bg-primary/10 text-primary" : "hover:bg-surface-2")}>
      <span className="font-mono-tabular shrink-0 max-w-[55%] truncate">{r.code}</span>
      <span className="truncate text-muted">{r.name || r.detail}</span>
      <span className="ml-auto shrink-0 text-[9.5px] uppercase tracking-widest text-subtle">{r.layer}</span>
    </button>
  );
}

export function SearchDropdown({ q, results, loading, error, active, onPick, onAsk }) {
  return (
    <div data-testid="global-search-results" className="absolute left-0 right-0 top-11 bg-surface border border-border rounded-md shadow-xl z-50 overflow-hidden animate-fade-in">
      {loading && !results.length && <div className="px-3 py-2.5 text-[12px] text-muted">Searching Silver and Gold tables…</div>}
      {!loading && error && <div data-testid="global-search-error" className="px-3 py-2.5 text-[12px] text-critical">{error}</div>}
      {!loading && !error && !results.length && (
        <div data-testid="global-search-empty" className="px-3 py-2.5 text-[12px] text-muted">No SKU, branch or supplier matches “{q}”.</div>
      )}
      <div className="max-h-[340px] overflow-y-auto">
        {results.map((r, i) => (
          <React.Fragment key={`${r.kind}-${r.code}`}>
            {(i === 0 || results[i - 1].kind !== r.kind) && (
              <div className="px-3 pt-2 pb-1 text-[10px] uppercase tracking-[0.2em] text-subtle font-semibold">{KIND_LABEL[r.kind]}</div>
            )}
            <Row r={r} on={i === active} onPick={onPick} />
          </React.Fragment>
        ))}
      </div>
      <button type="button" data-testid="global-search-ask-ai" onMouseDown={keep} onClick={onAsk}
              className={cn("w-full text-left px-3 py-2 border-t border-border flex items-center gap-2 text-[12.5px] font-medium text-primary transition-colors",
                active === results.length ? "bg-primary/10" : "hover:bg-primary/5")}>
        <Sparkles size={13} /> <span className="truncate">Ask AI about “{q}”</span>
        <CornerDownLeft size={12} className="ml-auto text-subtle" />
      </button>
    </div>
  );
}
